import { Module, MutationTree, ActionTree, GetterTree } from "vuex";

export class faqState {
  select: faq = "회원";
  list: faq[] = ["회원", "주문/결제", "배송조회", "취소/기타"];
  contentList: faqList = {
    회원: [
      {
        title: "회원가입은 어떻게 하나요?",
        content:
          "이용하는 오피스에 디포스트가 입점해 있다면 우측 상단의 [회원가입]을 클릭하여 간단한 인증 절차 후 회원 가입을 완료할 수 있어요.",
      },
      {
        title: "회원 정보를 변경하고 싶어요.",
        content: `[마이페이지]에서 비밀번호, 이용지점을 변경할 수 있어요. 
이용지점은 주문접수 시 보내는 분/출발지 주소로 사용되오니 변경 전 다시 한번 확인해 주세요.

전화번호 변경은 아래 고객센터로 문의해 주세요.
<b>*고객센터: 1811-4232</b>`,
      },
      {
        title: "아이디(이메일)/비밀번호가 기억나지 않아요.",
        content: `[로그인] 페이지의 [이메일 아이디를 잊으셨나요?] 및 [비밀번호를 잊으셨나요?]를 통해 가입하신 이메일 아이디와 비밀번호를 확인할 수 있어요. 
확인이 어려울 경우에는 아래 고객센터로 문의해 주세요. 
    <b>*고객센터: 1811-4232</b> `,
      },
      {
        title: "디포스트를 그만 이용하고 싶어요.",
        content: `회원탈퇴를 희망하시는 경우 고객센터로 문의해 주세요.
  <b>*고객센터 : 1811-4232</b>`,
      },
    ],
    "주문/결제": [
      {
        title: "주문접수는 어떻게 하나요?",
        content: `1. 상단 [주문접수] 메뉴에서 원하는 접수 유형을 선택해요.

2. 배송에 필요한 정보를 입력한 후 [주문접수] 버튼을 클릭해요.

3. 결제 유형을 선택하여 주문접수를 완료해요.

4. 보내실 물품에 접수코드를 작성하여 디포스트 또는 디포스트 무인발송스테이션에 전달해 주세요. 

디포스트가 안전하고 빠르게 물품을 전달해 드릴게요!`,
      },
      {
        title: "다량택배 접수는 어떻게 하나요?",
        content: `1. 상단 [주문접수] 메뉴에서 [다량택배접수]를 선택해요.

2. [파일받기]를 클릭하여 다량택배접수 양식을 다운로드받아요.

3. 정해진 양식에 맞추어 내용을 작성하신 후에 [파일올리기]를 클릭하여 작성한 양식을 업로드해요.

4. 다량택배 발송리스트를 확인하여 최종 목록을 확인 후에 [주문접수]를 클릭해요.

5. 결제 유형을 선택하여 주문접수를 완료해요.

6. 보내실 물품에 접수코드를 작성하여 디포스트 또는 디포스트 무인발송스테이션에 전달해 주세요. 

*다량택배접수 양식에 내용이 올바르게 입력되지 않은 항목이 있을 경우 주문 접수가 진행되지 않아요.
*보내는 분 주소 변경을 희망하실 경우에는 물품 접수 시 담당 매니저에게 요청해 주시면 변경해 드려요.`,
      },
      {
        title: "한 번에 몇 개까지 접수 할 수 있나요?",
        content: `택배와 퀵 모두 최대 <b>5건</b>까지 한 번에 접수할 수 있어요.`,
      },
      {
        title: "포장은 직접 해야 하나요?",
        content: `배송 중 발생할 수 있는 사고를 방지하기 위해 물품은 고객님께서 직접 포장하여 접수해 주세요.

포장 용품이 필요하신 경우, 디포스트 이용 지점에서 구매할 수 있어요. 
지점 별 판매하는 품목이 상이하므로, 문의 후 방문해 주세요.`,
      },
      {
        title: "이용 운임이 궁금해요.",
        content: `1. 택배
  • 유인점 - 기본 요금: 3,850원(VAT포함)
  • 무인점 - 기본 요금: 4,950원 (VAT포함)
  *택배 규격에 따라 요금이 달라질 수 있어요.
  *제주 및 도서/산간 지역으로 발송하는 경우 추가 요금이 발생해요.
  <br />2. 퀵
  • 기본 요금: 7,700원(VAT포함)
  *물품의 무게, 배송 거리, 시간에 따라 추가 요금이 발생해요.`,
      },
      {
        title: "착불도 신청 가능한가요?",
        content: `디포스트는 선결제 주문 건에 한하여 발송이 가능해요.`,
      },
      {
        title: "출발지 주소를 변경할 수 있나요?",
        content: `1. 택배는 이용하시는 디포스트에 물품을 맡겨 주셔야 하기 때문에 출발지 주소 변경이 불가해요. 

2. 퀵은 [기사님에게 직접 전달할게요]를 선택하여 출발지 주소를 변경할 수 있어요.`,
      },
      {
        title: "자주 쓰는 배송지를 등록할 수 있나요?",
        content: `퀵 서비스에 한하여 자주 쓰는 배송지를 등록할 수 있어요.
상단 [주문접수] > [퀵접수] > 출발지, 도착지 우측의 [내 주소록]을 클릭하여 즐겨찾기와 최근 내역 기능을 이용해 보세요!`,
      },
      {
        title: "비회원 접수는 안되나요?",
        content: `현재 디포스트는 회원만 주문접수가 가능해요. 
디포스트는 일반 회원가입 및 네이버, 카카오 간편 회원가입 기능을 제공하고 있어요.
회원가입 후 디포스트의 다양한 서비스를 이용해 보세요!`,
      },
      {
        title: "결제 방법은 무엇이 있나요?",
        content: `카드 결제, 간편 결제(네이버 페이, 카카오 페이, 페이코), 그룹카드 결제, 월정산 그리고 지점방문 결제를 제공하고 있어요.

*월정산 관련 문의는 고객센터(1811-4232)로 문의주시면 친절하게 도와드릴게요.
*지점방문 결제는 카드 결제만 가능하니 카드 지참하여 디포스트에 방문해 주세요.`,
      },
      {
        title: "법인카드도 등록 가능한가요?",
        content: `법인카드도 등록 및 이용 가능해요.

[마이페이지] > [개인 결제 수단]에서 등록할 수 있으며, 주문접수 후 결제 페이지에서도 등록 가능해요.`,
      },
    ],
    배송조회: [
      {
        title:
          "접수 후 퀵 접수 번호, 운송장 번호, 등기 접수 번호는 언제 확인할 수 있나요?",

        content: `1. 택배
• 운송장번호는 디포스트에 물품을 전달하신 날을 기준으로 +1 영업일 이내 확인할 수 있어요. (택배사의 사정에 따라 달라질 수 있어요.)

2. 퀵
• 퀵은 나에게 맞춘 Fit 배송 디버를 통해 진행되며 디버 배송원 배정 시 디버 알림톡으로 알려드려요.

3. 등기
• 접수 및 발송일 기준 +1 영업일 이후 확인할 수 있어요.

택배 운송장번호 및 퀵/등기 접수번호는 모두 알림톡 및 디포스트 [배송조회] > [발송내역조회]에서 확인할 수 있어요.`,
      },
      {
        title: "배송은 얼마나 걸리나요?",
        content: `1. 택배
• 물품이 택배사에 전달되면 +2~3 영업일 이내 도착하며 최대 5일 정도 소요돼요. (배송 지역과 택배사 사정에 따라 달라질 수 있어요.)

2. 퀵 
• 배송 시 교통 상황에 따라 차이가 있어요. 
• 배송 관련 상세 사항은 디버 알림톡 또는 디버(1544-4805)로 문의해 주세요.

3. 등기
• 일반등기: 물품이 우체국에 전달되면 +3 영업일 이내 도착해요.
• 빠른등기: 물품이 우체국에 전달되면 +1 영업일 이내 도착해요.`,
      },
    ],

    "취소/기타": [
      {
        title: "주문 취소는 어떻게 하나요?",
        content: `상단 [배송조회] > [발송내역조회] > [상세보기]에서 취소하려는 주문을 선택 후 [주문취소] 버튼을 클릭하여 주문을 취소할 수 있어요.`,
      },
      {
        title: "퀵 주문 취소는 언제까지 가능한가요?",
        content: `퀵은 주문상태와 결제방법에 따라 주문 취소 가능 여부가 상이해요.

<span class="font-semibold">[주문상태]</span>
주문상태는 웹접수완료 - 결제완료 - 지점접수완료 - 발송대기 - 발송완료 단계로 구성되어 있어요.
• <span class="font-semibold">웹접수완료, 결제완료, 지점접수완료, 발송대기</span> 단계의 퀵 주문은 <span class="font-semibold">디포스트 웹에서 취소할 수 있어요.</span>
• 발송완료 단계의 퀵 주문은 취소가 불가해요.

<span class="font-semibold">[결제방법]</span>
• 결제방법이 개인 결제, 간편 결제, 월정산, 그룹카드 결제인 경우 위 주문상태에 따라 결제 취소가 자동으로 진행돼요.
• 결제방법이 지점방문결제인 경우 결제하신 카드 및 영수증을 지참하여 이용하신 디포스트 지점에 방문해 주시면 결제 취소가 진행돼요. `,
      },
      {
        title: "택배 주문 취소는 언제까지 가능한가요?",
        content: `택배는 주문상태와 결제방법에 따라 주문 취소 가능 여부가 상이해요.

<span class="font-semibold">[주문상태]</span>
주문상태는 웹접수완료 - 결제완료 - 지점접수완료 - 발송대기 - 발송완료 단계로 구성되어 있어요.
• <span class="font-semibold">웹접수완료, 결제완료</span> 단계의 택배 주문은 <span class="font-semibold">디포스트 웹에서 취소할 수 있어요.</span>
• 지점접수완료, 발송대기 단계의 택배 주문은 디포스트에 취소 문의해 주세요.
• 발송완료 단계의 택배 주문은 취소가 불가해요.

<span class="font-semibold">[결제방법]</span>
• 결제방법이 개인결제, 간편결제, 월정산, 그룹카드결제인 경우 위 주문상태에 따라 결제 취소가 자동으로 진행돼요.
• 결제방법이 지점방문결제인 경우 결제하신 카드 및 영수증을 지참하여 이용하신 디포스트 지점에 방문해 주시면 결제 취소가 진행돼요. `,
      },

      {
        title: "등기/국제우편 주문 취소는 언제까지 가능한가요?",
        content: `등기/국제우편은 주문상태와 결제방법에 따라 주문 취소 가능 여부가 상이해요.

<span class="font-semibold">[주문상태]</span>
주문상태는 웹접수완료 - 결제완료 - 지점접수완료 - 발송대기 - 발송완료 단계로 구성되어 있어요.
• <span class="font-semibold">웹접수완료, 결제완료</span> 단계의 등기/국제우편 주문은 <span class="font-semibold">디포스트 웹에서 취소할 수 있어요.</span>
• 지점접수완료 단계의 등기/국제우편 주문은 디포스트에 취소 문의해 주세요.
• 발송대기, 발송완료 단계의 등기/국제우편 주문은 취소가 불가해요.

<span class="font-semibold">[결제방법]</span>
• 결제방법이 개인결제, 간편결제, 월정산, 그룹카드결제인 경우 위 주문상태에 따라 결제 취소가 자동으로 진행돼요.
• 결제방법이 지점방문결제인 경우 결제하신 카드 및 영수증을 지참하여 이용하신 디포스트 지점에 방문해 주시면 결제 취소가 진행돼요. `,
      },

      {
        title: "반품 신청도 가능한가요?",
        content: `1. 택배
• 택배사에 직접 반품 신청해 주세요.

2. 퀵
• 상단 [주문접수] > [퀵 접수]에서 반품을 위한 퀵 주문을 재접수해 주세요.`,
      },

      {
        title: "영수증, 거래 명세서 발급이 가능한가요?",
        content: `영수증은 결제 카드사를 통해 발급해 주세요.
디포스트 지점 방문 후 결제하신 고객님은 결제하신 카드를 지참하여 이용하신 디포스트 지점에 방문해 주시면 영수증 발급이 가능해요.


거래 명세서는 [배송조회] > [발송내역조회] > [상세보기] > [거래명세서]를 클릭하여 다운로드할 수 있어요.

단, 접수하신 주문의 상태가 <span class="font-semibold">발송완료, 취소완료</span> 단계인 경우에만 다운로드할 수 있어요.`,
      },
    ],
  };
}
const Mutations: MutationTree<faqState> = {
  updateSelect(state, payload: faq) {
    state.select = payload;
  },
};
const Actions: ActionTree<faqState, any> = {
  updateSelect({ commit }, payload: faq) {
    commit("updateSelect", payload);
  },
};
const Getters: GetterTree<faqState, any> = {
  getSelectedInfomation: (state: faqState) => () => {
    const list = state.contentList[state.select];
    for (let i = 0; i < list.length; i++) {
      list[i].checked = false;
    }
    return list;
  },
};

const module: Module<faqState, any> = {
  namespaced: true,
  state: new faqState(),
  mutations: Mutations,
  actions: Actions,
  getters: Getters,
};

export default module;
